import { createAsyncThunk } from "@reduxjs/toolkit";
import { ICartRequestView } from "../../modules/cart/models/ICartRequestView";
import {  ICartResponseView } from "../../modules/cart/models/ICartResponseView";
import { AuthUtil } from "../../utils/AuthUtil";
import { CartService } from "../../modules/cart/services/cartService";

/**
 * Create a Cart
 */
export const createCartAction = createAsyncThunk<
  { data: ICartResponseView; msg: string; status: string },
  { cart: ICartRequestView },
  { rejectValue: any }
>(
  "carts/createCartAction",
  async (payload, { rejectWithValue }) => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const { cart } = payload;
        const response = await CartService.createCart(cart);
        return response.data;
      }
      throw new Error("Failed to set token to request header");
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

/**
 * Get Cart Info
 */
export const getCartInfoAction = createAsyncThunk<
  { data: ICartResponseView; msg: string; status: string },
  void,
  { rejectValue: any }
>(
  "carts/getCartInfoAction",
  async (_, { rejectWithValue }) => {
    try {
      if (AuthUtil.setTokenToRequestHeader()) {
        const response = await CartService.getCartInfo();
        return response.data;
      }
      throw new Error("Failed to set token to request header");
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
